import application from 'application/application';

import templateUrl from './module-schedule.template.html';

import controller from './module-schedule.controller';

application.config([
    '$stateProvider',
    $stateProvider => {
        $stateProvider.state('root.default.module-schedule', {
            url: '/agenda',
            views: {
                'default@root.default': { templateUrl, controller }
            },
            data: {
                documentTitle: 'Agenda'
            }
        });
    }
]);
